import { cn } from "@/lib/cn";

import { Header } from "@/components/Header";

const teamImage = "/images/landing/team.png";

// Info Card Component
interface InfoCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const InfoCard = ({ title, children, className }: InfoCardProps) => (
  <div
    className={cn(
      "rounded-mds flex flex-col gap-2 border border-neutral-200/7 bg-neutral-200/2 p-4",
      "fs-700 font-bold text-neutral-100",
      className
    )}
  >
    <p className="fs-300 font-semibold text-neutral-200/61">{title}</p>
    {children}
  </div>
);

// Stat Item Component
interface StatItemProps {
  value: string;
  label: string;
}

const StatItem = ({ value, label }: StatItemProps) => (
  <div className="flex flex-col">
    <span className="text-neutral-50 fs-800 font-bold">{value}</span>
    <span className="fs-300 font-semibold text-neutral-200/61">{label}</span>
  </div>
);

// ============ Main ProtectPage ============
export const ProtectPage = () => {
  return (
    <div className="bg-background min-h-screen">
      <Header variant="profile" />
      <main className="mx-auto flex max-w-360 flex-col items-center gap-12 px-4 pt-10 pb-27 md:px-6">
        {/* Team Image */}
        <div className="relative h-100 w-full overflow-hidden md:h-131">
          <img
            src={teamImage}
            alt="Team"
            className="h-full w-full object-contain object-center"
          />
        </div>

        <div className="mx-auto flex max-w-178 flex-col items-center">
          {/* Info Cards */}
          <div className="flex w-full flex-col gap-4">
            {/* Main Principle Card */}
            <InfoCard title="Основной прицип">
              <div className="flex flex-col gap-7">
                <p className="fs-700 font-bold text-neutral-100">
                  Бот корректирует стратегию под Ваш уровень риска, основываясь на подкрепленных
                  стратегиях, на которых тестировалась работа
                </p>
                <div className="flex flex-wrap items-start justify-between gap-8">
                  <StatItem
                    value="$30 000"
                    label="Потратили на тестирование"
                  />
                  <StatItem
                    value="$10 000"
                    label="Заработали по откалиброванным стратегиям"
                  />
                </div>
              </div>
            </InfoCard>

            {/* Payment Card */}
            <InfoCard title="Оплата">
              <p className="fs-700 font-bold text-neutral-100">
                Каждый месяц с вашего кошелька списывается{" "}
                <span className="text-primary-500">30% от прибыли, полученной ботом</span>
              </p>
            </InfoCard>

            {/* Security Card */}
            <InfoCard title="Безопасность">
              <p className="fs-700 font-bold text-neutral-100">
                Все ваши данные хранятся в строго охраняемом месте, мы гарантируем полную
                безопасность личной информации
              </p>
            </InfoCard>
          </div>
        </div>
      </main>
    </div>
  );
};
